import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-offline-card-presentation',
  templateUrl: './offline-card-presentation.component.html',
  styleUrls: ['./offline-card-presentation.component.scss']
})
export class OfflineCardPresentationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
